import React from 'react';

import { Heading1 } from '../../../_common/Typography';

type Props = {
  children?: React.ReactNode | string;
};

export const ModuleHeader = ({ children }: Props) => (
  <div className="header-with-button flex items-center justify-between mb-4 w-full">
    {children}
  </div>
);

export const ModuleHeaderTitle = ({ children }: Props) => (
  <Heading1>
    <div className="flex font-normal">{children}</div>
  </Heading1>
);
